export var ASSET_TYPE;
(function (ASSET_TYPE) {
  ASSET_TYPE["MODEM"] = "MODEM";
  ASSET_TYPE["ROUTER"] = "ROUTER";
  ASSET_TYPE["IP_ADDRESS"] = "IP_ADDRESS";
})(ASSET_TYPE || (ASSET_TYPE = {}));